export const NAME = "targetedKeywords";
